// extracted by mini-css-extract-plugin
export var resizer = "_cw-0";